module.exports = __webpack_public_path__ + "static/media/toyota-parking-selected.5f8a3766.svg";